module.exports = __webpack_public_path__ + "img/lift2.a338bb09.png";